//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { WebsiteRenderContextTeacherNameDisplayItem } from './WebsiteRenderContextTeacherNameDisplayItem';
import { TagDisplayItem } from './TagDisplayItem';
import { PaymentProcessorDisplayItem } from './PaymentProcessorDisplayItem';
import { PaymentSurchargeDisplayItem } from './PaymentSurchargeDisplayItem';
import { WebsiteBlockRenderContextDisplayItem } from './WebsiteBlockRenderContextDisplayItem';

export class WebsiteBlockSignupFormRenderContextDisplayItem extends WebsiteBlockRenderContextDisplayItem {
    PreferredTeachers: WebsiteRenderContextTeacherNameDisplayItem[] = [];
    SubjectTags: TagDisplayItem[] = [];
    ForceAutoPay: boolean = false;
    CanSetTimeZone: boolean = false;
    CurrencyCode: string | null = null;
    PaymentProcessor: PaymentProcessorDisplayItem | null = null;
    PaymentSurchargeCreditCard: PaymentSurchargeDisplayItem | null = null;
    PaymentSurchargeACH: PaymentSurchargeDisplayItem | null = null;
    AdvanceBookingLimitDays: number = 0;

    constructor(initializer?: Partial<WebsiteBlockSignupFormRenderContextDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteBlockSignupFormRenderContextDisplayItem";
}
